import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-list-empty-state',
    templateUrl: './list-empty-state.component.html',
    styleUrls: ['./list-empty-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListEmptyStateComponent implements OnInit {
  @Input() public title: string;
  @Input() public text: string;
  @Input() public icon: string;
  
  @Input() public pageMode = false;
  
  constructor() { }

  ngOnInit(): void {
  }

}
